import { Component } from '@angular/core';
import { OrdersService } from '../../services/orders.service';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'order-history',
  styleUrls: ['./orders.component.scss'],
  templateUrl: './orders.component.html',
})
export class OrdersComponent {
  public isLoading;
  public orders = [];

  constructor(
    public ordersService: OrdersService,
    private firebaseService: FirebaseService
  ) {
    this.isLoading = true;
    this.ordersService.get().subscribe(
      (data: any) => {
        this.isLoading = false;
        this.orders = data['results'];
        const reducer = (accumulator, item) => accumulator + item.quantity;
        this.firebaseService.userProperties({
          order_count: data.count,
          print_count: data.results.reduce(reducer, 0),
        });
      },
      data => {
        this.isLoading = false;
      }
    );
  }
}
